export default __webpack_public_path__ + "static/media/MrsModupe.def77ed3.png";